import React from "react";

import SvgHelpCircle from "@uui/HelpCircle";

import FormControlLabel from "@mui/material/FormControlLabel";

import { ReadAverageIcon } from "@app/common/assets/icons";
import { TOOLTIPS } from "@app/common/content";

import { Row } from "@rui/Stack";
import Switch from "@rui/Switch";
import TooltipWrapper from "@rui/TooltipWrapper";

import { MEETING_POLICY_TABS } from "./meetingPolicyUtils";
import {
  Legend,
  LegendItemContainer,
  LegendLabel,
  ToggleLabel,
} from "./styles";
import type { MeetingPolicyMetric, ToggleState } from "./types";

export const Toggles = ({
  toggleState,
  onToggle,
}: {
  onToggle: (toggles: ToggleState) => void;
  toggleState: ToggleState;
}) => {
  const { chartLabels, meetingCount, readAverage } = toggleState;

  const handleToggle = (
    toggle: "chartLabels" | "meetingCount" | "readAverage"
  ) => {
    const newState = { ...toggleState, [toggle]: !toggleState[toggle] };

    onToggle(newState);
  };

  return (
    <Row variant="left" sx={{ overflowX: "hidden" }}>
      <FormControlLabel
        control={
          <Switch
            checked={chartLabels}
            onChange={() => handleToggle("chartLabels")}
          />
        }
        sx={{ marginLeft: "0px" }}
        label={<ToggleLabel>Chart Labels</ToggleLabel>}
      />
      <FormControlLabel
        control={
          <Switch
            checked={readAverage}
            onChange={() => handleToggle("readAverage")}
          />
        }
        label={<ToggleLabel>Read Average</ToggleLabel>}
      />
      <FormControlLabel
        control={
          <Switch
            checked={meetingCount}
            onChange={() => handleToggle("meetingCount")}
          />
        }
        label={<ToggleLabel>Meeting [Count]</ToggleLabel>}
      />
    </Row>
  );
};

interface LegendAndTogglesProps {
  onToggle: (toggles: ToggleState) => void;
  selectedMetric: MeetingPolicyMetric;
  toggleState: ToggleState;
}

const LegendAndToggles = ({
  selectedMetric,
  ...toggleProps
}: LegendAndTogglesProps) => {
  const selectedMetricLabel = MEETING_POLICY_TABS.find(
    (tab) => tab.id === selectedMetric
  )!.label;

  return (
    <Row
      sx={{ pt: 2 }}
      spacing={1}
      justifyContent="space-between"
      flexWrap="wrap"
    >
      <Row alignItems="stretch" spacing={1}>
        <LegendItemContainer variant="center">
          <LegendLabel>{selectedMetricLabel}: Low</LegendLabel>
          <Legend />
          <LegendLabel>High</LegendLabel>
        </LegendItemContainer>
        <LegendItemContainer variant="center" spacing={1}>
          <ReadAverageIcon />
          <LegendLabel>Read Average</LegendLabel>
          <TooltipWrapper
            placement="top"
            title={TOOLTIPS.meetingPolicy.readAverage}
          >
            <SvgHelpCircle
              sx={{ fontSize: "12px", color: "shades.neutral.200" }}
            />
          </TooltipWrapper>
        </LegendItemContainer>
      </Row>
      <Toggles {...toggleProps} />
    </Row>
  );
};

export default LegendAndToggles;
